import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .legal-root { font-family: 'DM Sans', sans-serif; color: #0f1117; background: #ffffff; overflow-x: hidden; }
  .legal-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 999; padding: 0 32px; height: 68px; display: flex; align-items: center; justify-content: space-between; background: rgba(255,255,255,0.92); backdrop-filter: blur(12px); border-bottom: 1px solid rgba(0,0,0,0.08); box-shadow: 0 2px 20px rgba(0,0,0,0.06); }
  .legal-nav-logo { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; text-decoration: none; display: flex; align-items: center; gap: 10px; letter-spacing: -0.3px; }
  .legal-logo-icon { width: 36px; height: 36px; background: #1a5c2a; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .legal-nav-links { display: flex; align-items: center; gap: 8px; }
  .legal-btn-signin { font-size: 14px; font-weight: 600; color: #1a5c2a; text-decoration: none; padding: 9px 20px; border: 1.5px solid #1a5c2a; border-radius: 10px; transition: all 0.2s; }
  .legal-btn-signin:hover { background: #1a5c2a; color: white; }
  .legal-btn-start { font-size: 14px; font-weight: 600; color: white; text-decoration: none; padding: 9px 20px; background: #1a5c2a; border-radius: 10px; transition: all 0.2s; box-shadow: 0 2px 8px rgba(26,92,42,0.35); }
  .legal-btn-start:hover { background: #145022; }
  .legal-hero { background: linear-gradient(135deg, #0a1f0f 0%, #1a5c2a 50%, #0d3318 100%); padding: 120px 24px 64px; text-align: center; position: relative; overflow: hidden; }
  .legal-hero::after { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px); background-size: 32px 32px; pointer-events: none; }
  .legal-hero-tag { display: inline-flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: rgba(255,255,255,0.9); font-size: 13px; font-weight: 500; padding: 6px 16px; border-radius: 50px; margin-bottom: 20px; position: relative; z-index: 1; }
  .legal-hero h1 { font-family: 'Syne', sans-serif; font-size: clamp(36px, 5vw, 60px); font-weight: 800; color: white; letter-spacing: -2px; margin-bottom: 16px; position: relative; z-index: 1; }
  .legal-hero-sub { font-size: 16px; color: rgba(255,255,255,0.65); position: relative; z-index: 1; }
  .legal-body { max-width: 820px; margin: 0 auto; padding: 64px 24px 80px; }
  .legal-toc { background: #f8faf8; border: 1px solid #e8f0e8; border-radius: 16px; padding: 28px 32px; margin-bottom: 48px; }
  .legal-toc-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 16px; }
  .legal-toc-list { list-style: none; display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; }
  .legal-toc-list li a { font-size: 14px; color: #1a5c2a; text-decoration: none; font-weight: 500; transition: color 0.2s; }
  .legal-toc-list li a:hover { color: #145022; text-decoration: underline; }
  .legal-section { margin-bottom: 48px; scroll-margin-top: 88px; }
  .legal-section-title { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #e8f5e9; display: flex; align-items: center; gap: 10px; }
  .legal-section-title span { width: 32px; height: 32px; background: #1a5c2a; color: white; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; flex-shrink: 0; }
  .legal-subsection { margin-bottom: 20px; }
  .legal-subsection-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 8px; }
  .legal-p { font-size: 15px; line-height: 1.75; color: #333; margin-bottom: 12px; }
  .legal-list { list-style: none; margin: 8px 0 12px 0; }
  .legal-list li { font-size: 15px; line-height: 1.75; color: #333; padding: 6px 0 6px 24px; border-bottom: 1px solid #f0f0f0; position: relative; }
  .legal-list li:last-child { border-bottom: none; }
  .legal-list li::before { content: '✓'; position: absolute; left: 0; color: #1a5c2a; font-weight: 700; }
  .legal-highlight { background: #e8f5e9; border-left: 4px solid #1a5c2a; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-highlight p { font-size: 14px; color: #1a5c2a; font-weight: 500; line-height: 1.6; margin: 0; }
  .legal-warning { background: #fff8e1; border-left: 4px solid #f59e0b; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-warning p { font-size: 14px; color: #92400e; font-weight: 500; line-height: 1.6; margin: 0; }

  /* ── Refund table ── */
  .refund-table { width: 100%; border-collapse: collapse; margin: 16px 0 24px; border-radius: 12px; overflow: hidden; border: 1px solid #e0e0e0; }
  .refund-table th { background: #1a5c2a; color: white; font-family: 'Syne', sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; padding: 12px 16px; text-align: left; }
  .refund-table td { padding: 12px 16px; font-size: 14px; border-bottom: 1px solid #f0f0f0; vertical-align: top; line-height: 1.5; }
  .refund-table tr:last-child td { border-bottom: none; }
  .refund-table tr:nth-child(even) td { background: #f8faf8; }
  .badge-yes { display: inline-block; background: #dcfce7; color: #166534; font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 50px; }
  .badge-no { display: inline-block; background: #fee2e2; color: #991b1b; font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 50px; }

  /* ── Steps ── */
  .refund-steps { margin: 16px 0; }
  .refund-step { display: flex; gap: 16px; padding: 16px 0; border-bottom: 1px solid #f0f0f0; align-items: flex-start; }
  .refund-step:last-child { border-bottom: none; }
  .refund-step-num { width: 32px; height: 32px; background: #1a5c2a; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-family: 'Syne', sans-serif; font-weight: 800; font-size: 14px; flex-shrink: 0; }
  .refund-step-content { flex: 1; }
  .refund-step-content strong { display: block; font-size: 15px; color: #0f1117; margin-bottom: 4px; }
  .refund-step-content span { font-size: 14px; color: #555; line-height: 1.6; }

  .legal-contact-card { background: linear-gradient(135deg, #0a1f0f, #1a5c2a); border-radius: 16px; padding: 32px; text-align: center; margin-top: 56px; }
  .legal-contact-card h3 { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: white; margin-bottom: 8px; }
  .legal-contact-card p { font-size: 15px; color: rgba(255,255,255,0.7); margin-bottom: 20px; }
  .legal-contact-btn { display: inline-block; background: white; color: #1a5c2a; font-weight: 700; font-size: 15px; text-decoration: none; padding: 12px 28px; border-radius: 10px; transition: all 0.2s; }
  .legal-contact-btn:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.2); }
  .legal-footer { background: #0f1117; padding: 48px 32px 32px; }
  .legal-footer-inner { max-width: 1100px; margin: 0 auto; display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 32px; padding-bottom: 32px; border-bottom: 1px solid rgba(255,255,255,0.08); }
  .legal-footer-brand { font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800; color: white; display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
  .legal-footer-tagline { font-size: 13px; color: rgba(255,255,255,0.4); max-width: 220px; }
  .legal-footer-col-title { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.5); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 16px; }
  .legal-footer-link { display: block; font-size: 14px; color: rgba(255,255,255,0.6); text-decoration: none; margin-bottom: 10px; transition: color 0.2s; }
  .legal-footer-link:hover { color: white; }
  .legal-footer-bottom { max-width: 1100px; margin: 24px auto 0; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; font-size: 13px; color: rgba(255,255,255,0.3); }
  @media (max-width: 768px) { .legal-nav { padding: 0 16px; } .legal-toc-list { grid-template-columns: 1fr; } .legal-footer-inner { flex-direction: column; } .legal-body { padding: 48px 16px 64px; } .refund-table { font-size: 13px; } }
`;

export default function RefundPolicy() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sections = [
    { id: 'overview',    num: '1', title: 'Overview' },
    { id: 'monthly',     num: '2', title: 'Monthly Subscription Refunds' },
    { id: 'annual',      num: '3', title: 'Annual Subscription Refunds' },
    { id: 'setup',       num: '4', title: 'Setup Fee' },
    { id: 'exceptions',  num: '5', title: 'Exceptions' },
    { id: 'cancel',      num: '6', title: 'How to Cancel' },
    { id: 'request',     num: '7', title: 'How to Request a Refund' },
    { id: 'chargebacks', num: '8', title: 'Chargebacks' },
    { id: 'contact',     num: '9', title: 'Contact' },
  ];

  return (
    <div className="legal-root">
      <style>{styles}</style>

      {/* Navbar */}
      <nav className="legal-nav">
        <Link to="/" className="legal-nav-logo">
          <div className="legal-logo-icon">🍽️</div>
          QR Menu
        </Link>
        <div className="legal-nav-links">
          <Link to="/login" className="legal-btn-signin">Sign In</Link>
          <Link to="/register" className="legal-btn-start" style={{ marginLeft: 8 }}>Get Started</Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="legal-hero">
        <div className="legal-hero-tag">
          <span style={{ width: 8, height: 8, background: '#4ade80', borderRadius: '50%', display: 'inline-block' }} />
          Legal Document
        </div>
        <h1>Refund Policy</h1>
        <p className="legal-hero-sub">Last updated: May 24, 2026 · QR Digi Menu Inc. — A Delaware Corporation</p>
      </div>

      {/* Body */}
      <div className="legal-body">

        <p className="legal-p" style={{ fontSize: 16, color: '#444', marginBottom: 40 }}>
          We want every restaurant on QR Digi Menu to succeed. This Refund Policy is designed to be
          clear, fair, and transparent so you know exactly what to expect before and after purchasing.
          By purchasing a subscription, you agree to the terms of this policy.
        </p>

        {/* TOC */}
        <div className="legal-toc">
          <div className="legal-toc-title">📌 Table of Contents</div>
          <ul className="legal-toc-list">
            {sections.map(s => (
              <li key={s.id}><a href={`#${s.id}`}>{s.num}. {s.title}</a></li>
            ))}
          </ul>
        </div>

        {/* Section 1 */}
        <div className="legal-section" id="overview">
          <div className="legal-section-title"><span>1</span>Overview</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { icon: '📅', label: 'Monthly Plans', val: 'No refunds', sub: 'Cancel anytime', color: '#fee2e2', text: '#991b1b' },
              { icon: '📆', label: 'Annual Plans', val: '7-day window', sub: 'Conditions apply', color: '#fef9c3', text: '#854d0e' },
              { icon: '⚡', label: 'Setup Fee', val: 'Non-refundable', sub: 'Once access granted', color: '#fee2e2', text: '#991b1b' },
            ].map(c => (
              <div key={c.label} style={{ background: c.color, borderRadius: 12, padding: '20px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>{c.icon}</div>
                <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 14, color: '#0f1117', marginBottom: 4 }}>{c.label}</div>
                <div style={{ fontWeight: 700, fontSize: 13, color: c.text }}>{c.val}</div>
                <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>{c.sub}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Section 2 */}
        <div className="legal-section" id="monthly">
          <div className="legal-section-title"><span>2</span>Monthly Subscription Refunds</div>
          <table className="refund-table">
            <thead>
              <tr>
                <th>Timeframe</th>
                <th>Refund?</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Before first charge</td>
                <td><span className="badge-yes">Full Refund</span></td>
                <td>Cancel before trial or first billing date</td>
              </tr>
              <tr>
                <td>During current billing period</td>
                <td><span className="badge-no">No Refund</span></td>
                <td>Access continues until period ends; cancel to stop renewal</td>
              </tr>
              <tr>
                <td>Auto-renewal charge</td>
                <td><span className="badge-no">No Refund</span></td>
                <td>Cancel at least 24 hours before renewal date to avoid charge</td>
              </tr>
            </tbody>
          </table>
          <div className="legal-highlight">
            <p>💡 Monthly subscribers can cancel anytime from their account settings. You will not be charged again after the current period ends.</p>
          </div>
        </div>

        {/* Section 3 */}
        <div className="legal-section" id="annual">
          <div className="legal-section-title"><span>3</span>Annual Subscription Refunds</div>
          <table className="refund-table">
            <thead>
              <tr>
                <th>Timeframe</th>
                <th>Refund?</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Within 7 days of initial purchase</td>
                <td><span className="badge-yes">Full Refund*</span></td>
                <td>Only if no QR code has been printed and deployed to customers</td>
              </tr>
              <tr>
                <td>After 7 days from initial purchase</td>
                <td><span className="badge-no">No Refund</span></td>
                <td>Cancel to prevent future annual renewal</td>
              </tr>
              <tr>
                <td>Annual renewal charge</td>
                <td><span className="badge-no">No Refund</span></td>
                <td>Cancel at least 3 days before renewal date to avoid charge</td>
              </tr>
            </tbody>
          </table>
          <div className="legal-warning">
            <p>⚠ We will send an email reminder 7 days before each annual renewal date so you have time to cancel if needed.</p>
          </div>
        </div>

        {/* Section 4 */}
        <div className="legal-section" id="setup">
          <div className="legal-section-title"><span>4</span>Setup Fee</div>
          <p className="legal-p">A one-time setup fee, where applicable, is <strong>non-refundable</strong> once the account has been created and access to the platform has been granted. This covers the time and resources involved in initial account configuration.</p>
        </div>

        {/* Section 5 */}
        <div className="legal-section" id="exceptions">
          <div className="legal-section-title"><span>5</span>Exceptions — When We Will Issue a Refund</div>
          <p className="legal-p">Regardless of the above, we may issue a full or partial refund at our sole discretion in the following circumstances:</p>
          <ul className="legal-list">
            <li>Verified platform outage of <strong>24 or more consecutive hours</strong> within your billing period (prorated account credit)</li>
            <li>Confirmed <strong>duplicate charge</strong> caused by a billing system error on our end</li>
            <li><strong>Unauthorized charge</strong> due to documented account compromise, reported within 7 calendar days</li>
            <li>Service delivered was <strong>materially and substantially different</strong> from what was described at the time of purchase</li>
          </ul>
          <p className="legal-p">Exception requests are reviewed on a case-by-case basis. Submitting a request does not guarantee approval.</p>
        </div>

        {/* Section 6 */}
        <div className="legal-section" id="cancel">
          <div className="legal-section-title"><span>6</span>How to Cancel Your Subscription</div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">Method 1 — Self-Service (Recommended)</div>
            <div className="refund-steps">
              {[
                { label: 'Log in to your admin dashboard', detail: 'Go to getqrdigimenu.com/admin' },
                { label: 'Open Settings → Subscription', detail: 'Click on "Manage Billing"' },
                { label: 'Click "Cancel Subscription"', detail: 'Confirm the cancellation when prompted' },
                { label: 'Done', detail: 'You will receive a confirmation email' },
              ].map((s, i) => (
                <div key={i} className="refund-step">
                  <div className="refund-step-num">{i + 1}</div>
                  <div className="refund-step-content">
                    <strong>{s.label}</strong>
                    <span>{s.detail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">Method 2 — Email</div>
            <div className="refund-steps">
              {[
                { label: 'Email us', detail: 'Send to hello@getqrdigimenu.com' },
                { label: 'Subject line', detail: '"Cancel Subscription — [Your Account Email]"' },
                { label: 'We confirm within 1 business day', detail: 'Cancellation takes effect at end of current billing period' },
              ].map((s, i) => (
                <div key={i} className="refund-step">
                  <div className="refund-step-num">{i + 1}</div>
                  <div className="refund-step-content">
                    <strong>{s.label}</strong>
                    <span>{s.detail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="legal-highlight">
            <p>✅ Cancellations take effect at the end of the current billing period. You retain full access until that date — no immediate cut-off.</p>
          </div>
        </div>

        {/* Section 7 */}
        <div className="legal-section" id="request">
          <div className="legal-section-title"><span>7</span>How to Request a Refund</div>
          <p className="legal-p">For refunds where eligible under this policy:</p>
          <div className="refund-steps">
            {[
              { label: 'Email hello@getqrdigimenu.com', detail: 'Use subject line: "Refund Request — [Your Account Email]"' },
              { label: 'Include required details', detail: 'Account email, date of charge, transaction ID (if available), reason for request' },
              { label: 'We respond within 3 business days', detail: 'We will confirm eligibility and next steps' },
              { label: 'Refund processed within 5–10 business days', detail: 'Returned to the original payment method used at purchase' },
            ].map((s, i) => (
              <div key={i} className="refund-step">
                <div className="refund-step-num">{i + 1}</div>
                <div className="refund-step-content">
                  <strong>{s.label}</strong>
                  <span>{s.detail}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Section 8 */}
        <div className="legal-section" id="chargebacks">
          <div className="legal-section-title"><span>8</span>Chargebacks</div>
          <div className="legal-warning">
            <p>⚠ If you initiate a chargeback with your bank or credit card company before contacting us to resolve the issue, we reserve the right to suspend or permanently terminate your account and contest the chargeback. We respond within 1 business day — please reach out first.</p>
          </div>
        </div>

        {/* Section 9 */}
        <div className="legal-section" id="contact">
          <div className="legal-section-title"><span>9</span>Contact</div>
          <ul className="legal-list">
            <li><strong>Company:</strong> QR Digi Menu Inc. (A Delaware Corporation)</li>
            <li><strong>Address:</strong> 8 The Green #23752, Dover, DE 19901</li>
            <li><strong>Email:</strong> <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a></li>
            <li><strong>Website:</strong> <a href="https://getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>getqrdigimenu.com</a></li>
          </ul>
        </div>

        {/* CTA */}
        <div className="legal-contact-card">
          <h3>Need a refund or have questions?</h3>
          <p>We respond to all refund requests within 3 business days.</p>
          <a href="mailto:hello@getqrdigimenu.com" className="legal-contact-btn">📧 Email Us</a>
        </div>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <div>
            <div className="legal-footer-brand">
              <div style={{ width: 32, height: 32, background: '#1a5c2a', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🍽️</div>
              QR Menu
            </div>
            <div className="legal-footer-tagline">The complete digital menu platform for modern restaurants.</div>
          </div>
          <div>
            <div className="legal-footer-col-title">Product</div>
            <Link to="/#features" className="legal-footer-link">Features</Link>
            <Link to="/#pricing" className="legal-footer-link">Pricing</Link>
            <Link to="/#how-it-works" className="legal-footer-link">How it works</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Account</div>
            <Link to="/register" className="legal-footer-link">Get Started</Link>
            <Link to="/login" className="legal-footer-link">Sign In</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Legal</div>
            <Link to="/privacy" className="legal-footer-link">Privacy Policy</Link>
            <Link to="/terms" className="legal-footer-link">Terms of Service</Link>
            <Link to="/refund" className="legal-footer-link" style={{ color: 'rgba(255,255,255,0.9)' }}>Refund Policy</Link>
          </div>
        </div>
        <div className="legal-footer-bottom">
          <span>© {new Date().getFullYear()} QR Digi Menu Inc. All rights reserved.</span>
          <span>Built for restaurants worldwide 🌍</span>
        </div>
      </footer>
    </div>
  );
}